import { isEqual, uniqBy } from 'lodash';
import * as ActionTypes from '../../actions/types/website/ThemeListingActionTypes';

const initialState = {
  busy: false,
  theme_group_views: [],
  color_options: [],
  selected_color_keys: [],
  result_count: 36,
  themeDetails: {},
  offset: 0,
  fromZola: false,
  currentTheme: {},
  themeKey: '',
  themeGroupKey: ''
};

const themesListingReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.THEMES_REQUESTED: {
      return Object.assign({}, state, { busy: true });
    }
    case ActionTypes.THEMES_RECEIVED: {
      const filtersMatch = isEqual(state.selected_color_keys.sort(), action.payload.selected_color_keys.sort());
      // Only update when color filters match
      if (!filtersMatch) {
        return Object.assign({}, state);
      }
      const existingThemes = state.theme_group_views ? state.theme_group_views : [];
      // Don't allow for duplicate themes in the listings
      const themes = uniqBy(existingThemes.concat(action.payload.theme_group_views), 'id');
      const listingResp = Object.assign({}, state, action.payload, { busy: false, theme_group_views: themes });
      return listingResp;
    }
    case ActionTypes.THEMES_RESET: {
      return Object.assign({}, state, { busy: true, theme_group_views: [], offset: 0, selected_color_keys: [], currentTheme: {} });
    }
    case ActionTypes.THEME_GROUP_RESET: {
      return Object.assign({}, state, { busy: true, offset: 0 });
    }
    case ActionTypes.THEME_REQUESTED: {
      return Object.assign({}, state, { busy: true });
    }
    case ActionTypes.THEME_RECEIVED: {
      return Object.assign({}, state, { themeDetails: action.payload });
    }
    case ActionTypes.THEME_FILTER_SELECTED: {
      return Object.assign({}, state, action.payload);
    }
    case ActionTypes.CHANGE_FLAG: {
      return {
        ...state,
        fromZola: true
      };
    }
    case ActionTypes.STORE_THEMEDETAIL_KEY: {
      return {
        ...state,
        themeKey: action.payload.themeKey,
        themeGroupKey: action.payload.themeGroupKey

      };
    }
    case ActionTypes.RESET_THEMEKEY: {
      return Object.assign({}, state, { themeKey: action.payload, currentTheme: {} });
    }
    // storing current theme selection
    case ActionTypes.CHANGE_CURRENT_THEME: {
      return Object.assign({}, state, { currentTheme: action.payload });
    }
    // resetting current theme selection
    // case ActionTypes.RESET_CURRENT_THEME: {
    //   return Object.assign({}, state, { themeKey: '' });
    // }
    default: return state;
  }
};

export default themesListingReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/website/theme_listing.js
 **/